import { useCallback } from 'react';
import { useAppDispatch, useAppSelector } from '../hooks';
import {
  fetchDivisionByBusinessUnitApiThunk,
  createDivisionApiThunk,
  updateDivisionApiThunk,
  deleteDivisionApiThunk,
  clearDivisionMessages,
} from './divisionSlice';
import { RootState } from '..';
import {
  CreateDivisionRequest,
  UpdateDivisonRequest,
  DeleteDivisionRequest,
  ListDivisionsRequest,
} from 'src/types/orbit/Division';

export const useDivision = () => {
  const dispatch = useAppDispatch();
  const divisionList = useAppSelector((state: RootState) => state.divisions.divisionList);
  const fetcDivisionsApiStatus = useAppSelector(
    (state: RootState) => state.divisions.fetcDivisionsApiStatus,
  );
  const createDivisionApiStatus = useAppSelector(
    (state: RootState) => state.divisions.createDivisionApiStatus,
  );
  const updateDivisionApiStatus = useAppSelector(
    (state: RootState) => state.divisions.updateDivisionApiStatus,
  );
  const deleteDivisionApiStatus = useAppSelector(
    (state: RootState) => state.divisions.deleteDivisionApiStatus,
  );

  const loadDivisionsByBusinessUnit = useCallback(
    (data: ListDivisionsRequest) => {
      dispatch(fetchDivisionByBusinessUnitApiThunk(data));
    },
    [dispatch],
  );

  const createDivision = useCallback(
    (data: CreateDivisionRequest) => {
      dispatch(createDivisionApiThunk(data));
    },
    [dispatch],
  );

  const updateDivision = useCallback(
    (data: UpdateDivisonRequest) => {
      dispatch(updateDivisionApiThunk(data));
    },
    [dispatch],
  );

  const deleteDivision = useCallback(
    (data: DeleteDivisionRequest) => {
      dispatch(deleteDivisionApiThunk(data));
    },
    [dispatch],
  );
  const clearAllDivisionApiMessages = useCallback(() => {
    dispatch(clearDivisionMessages());
  }, [dispatch]);
  return {
    divisionList,
    fetcDivisionsApiStatus,
    createDivisionApiStatus,
    updateDivisionApiStatus,
    deleteDivisionApiStatus,
    loadDivisionsByBusinessUnit,
    clearAllDivisionApiMessages,
    createDivision,
    updateDivision,
    deleteDivision,
  };
};
